import React, { PropTypes } from 'react';
import LinkWithFlags from 'common/LinkWithFlags';
import selectn from 'selectn';
import classNames from 'classnames';
import ProviderSettings from './ProviderSettings';

function BrandingElement(props) {
    if (!props.branding) {
        const backArrowStyle = {
            fontSize: '16px',
            color: '#FFFFFF'
        };

        const backTextStyle = {
            font: 'SF UI Text Regular',
            fontSize: '14px',
            color: '#FFFFFF'
        };

        const backStyle = {
            marginBottom: '10px'
        };
        return (
            <a style={backStyle} onClick={() => window.history.back()}>
                <span className="icon-font-before icon-caret-left-solid-before" style={backArrowStyle} />
                <span style={backTextStyle}>Back</span>
            </a>
        );
    }
    const { name: brandingName, logoUrl: brandingLogoUrl } = props.branding;
    return (
        <div className="playback__logo">
            <LinkWithFlags data-route="false" className="playback__logo__link" to="/">
                <picture>
                    <img
                        src={brandingLogoUrl}
                        className="imageLoaded"
                        alt={brandingName}
                        style={{ width: 'auto', maxWidth: 150 }}
                    />
                </picture>
            </LinkWithFlags>
        </div>
    );
}
BrandingElement.propTypes = {
    branding: PropTypes.shape({
        name: PropTypes.string,
        logoUrl: PropTypes.string
    })
};

const ProviderLogoPlayback = ({
    displayLogout,
    handleLogin,
    handleLogout,
    hideProviderLogo,
    loggedIn,
    providerInfo,
    branding
}) => {
    const headerClass = classNames('playback__header', {
        'playback__header--loggedIn': loggedIn
    });
    const imgSrc = selectn('images.colorWithNegativeBackground.href', providerInfo) ||
        selectn('images.logo.href', providerInfo) || '';
    const webLink = selectn('links.web.href', providerInfo) || '/watch';
    let target = '';
    let providerLogoEl = null;
    let providerSettingsEl = null;
    const providerImg = (imgSrc !== '') ?
        <img src={imgSrc} className="imageLoaded" style={{ verticalAlign: '2px' }} alt="Provider" /> : null;

    if (providerImg !== null) {
        target = '_blank';
    }

    if (!hideProviderLogo) {
        // PageShell CSS enforces a `display: none` rule on provider logos.
        // To avoid clashes with PageShell CSS, we overwrite styles here via JS inline styles
        providerLogoEl = (
            <div className="playback__provider" style={{ display: 'inline-block' }}>
                <a className="playback__logo__link" target={target} href={webLink}>
                    <picture>
                        {providerImg}
                    </picture>
                </a>
            </div>
        );

        providerSettingsEl = (
            <ProviderSettings
                displayLogout={displayLogout}
                handleLogin={handleLogin}
                handleLogout={handleLogout}
                providerInfo={providerInfo}
            />
        );
    }

    return (
        <header className={headerClass}>
            <BrandingElement branding={branding} />
            {providerLogoEl}
            {providerSettingsEl}
        </header>
    );
};

ProviderLogoPlayback.propTypes = {
    displayLogout: PropTypes.bool,
    handleLogin: PropTypes.func,
    handleLogout: PropTypes.func,
    hideProviderLogo: PropTypes.bool,
    loggedIn: PropTypes.bool,
    providerInfo: PropTypes.object,
    branding: PropTypes.shape({
        name: PropTypes.string,
        logoUrl: PropTypes.string
    })
};

ProviderLogoPlayback.defaultProps = {
    providerInfo: {}
};

export default ProviderLogoPlayback;



// WEBPACK FOOTER //
// ./app/webapp/branding/ProviderLogoPlayback.js